module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAtElEQVR4Ae3S0QnCMBAG4NxN4AiO4AbiCE6gb0neHCFO4FPIq47gBOImuoELJPEOFKRge23aQqE/BEIu+biEKDVnsgHJphDCEhFPAPCKMR6ttY+mMyhEbznnJ40Fz3mtCP6iKaWLMeagtd7S/C7BQYLS1V2ldqbammqbf88CbVEpDl1QCQ5d0SYcStA6HEtRDp3Z01e8/v4WKEUrnTuydtw59oV+Ondssam89yvVc4Yw54yYN2atoxP0pnicAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right/2.png
// module id = P/Hn
// module chunks = 25